import { render } from "./UserAccountsBar.vue?vue&type=template&id=71d6ae82&scoped=true"
import script from "./UserAccountsBar.vue?vue&type=script&lang=js"
export * from "./UserAccountsBar.vue?vue&type=script&lang=js"

import "./UserAccountsBar.vue?vue&type=style&index=0&id=71d6ae82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d6ae82"],['__file',"src/components/UserAccountsBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71d6ae82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71d6ae82', __exports__)) {
    api.reload('71d6ae82', __exports__)
  }
  
  module.hot.accept("./UserAccountsBar.vue?vue&type=template&id=71d6ae82&scoped=true", () => {
    api.rerender('71d6ae82', render)
  })

}


export default __exports__